import React, { useState } from 'react';
import { SxStyle } from '../../../../types';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import TextField from '@mui/material/TextField';
import { ArenaConfig } from '../types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import Button from '@mui/material/Button';
import { useStringsContext } from '../../../../contexts/strings';

const styles: SxStyle = {
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  addButton: {
    marginTop: '20px',
    marginLeft: '20px',
  },
  saveButton: {
    marginTop: '20px',
  },
  cancelButton: {
    marginTop: '20px',
  },
  removeButton: {
    marginLeft: '20px',
  },
};

export default function PushNotificationList({
  arenaConfig,
  submitNewPushChannelList,
}: {
  arenaConfig: ArenaConfig;
  submitNewPushChannelList: (channels: string[]) => void;
}) {
  const { strings } = useStringsContext();
  const pushChannels = arenaConfig.venue.pushChannels ?? [];
  const [open, setOpen] = React.useState(false);
  const [pushChannelList, setPushChannelList] = useState<string[]>(pushChannels);
  const [newChannel, setNewChannel] = useState<string>('');

  const startAddNewChannel = () => {
    setOpen(true);
  };

  const addToPushChannelList = () => {
    const newChannelList = pushChannelList.concat([newChannel]);
    setPushChannelList(newChannelList);
    setNewChannel('');
    setOpen(false);
  };

  const cancelAddNewChannel = () => {
    setOpen(false);
    setNewChannel('');
  };

  const handleNewChannelChange = (e: any) => {
    setNewChannel(e.target.value);
  };

  const removeChannelFromList = (channel: string) => {
    const modifiedPushChannelList = pushChannelList.filter((c) => c !== channel);
    setPushChannelList(modifiedPushChannelList);
  };

  const resetChannelList = () => {
    setPushChannelList(pushChannels);
  };

  const saveConfiguration = () => {
    submitNewPushChannelList(pushChannelList);
  };

  const showSaveAndResetButton =
    pushChannelList.filter((c) => !pushChannels.includes(c)).length > 0 ||
    pushChannels.filter((c) => !pushChannelList.includes(c)).length > 0;

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{strings.wifi.channels}</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {pushChannelList.map((channel) => (
            <TableRow sx={styles.root}>
              <TableCell>{channel}</TableCell>
              <TableCell align="right">
                <DeleteIcon color="error" onClick={() => removeChannelFromList(channel)} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {open && (
        <>
          <TextField
            fullWidth
            onChange={handleNewChannelChange}
            id="newChannel"
            label={strings.wifi.newChannel}
          />
          <Button
            sx={styles.cancelButton}
            variant="contained"
            onClick={cancelAddNewChannel}
            color="primary"
          >
            {strings.actions.cancel}
          </Button>
          <Button
            sx={styles.addButton}
            onClick={addToPushChannelList}
            variant="contained"
            color="primary"
          >
            {strings.actions.save}
          </Button>
        </>
      )}
      {!open && (
        <Button
          variant="contained"
          onClick={startAddNewChannel}
          color="primary"
          startIcon={<AddCircleIcon />}
        >
          {strings.wifi.addNewChannel}
        </Button>
      )}
      {showSaveAndResetButton && (
        <Button
          sx={styles.saveButton}
          variant="contained"
          color="primary"
          onClick={() => resetChannelList()}
        >
          {strings.actions.cancel}
        </Button>
      )}
      {showSaveAndResetButton && (
        <Button
          sx={styles.saveButton}
          variant="contained"
          color="primary"
          onClick={saveConfiguration}
        >
          {strings.actions.save}
        </Button>
      )}
    </>
  );
}
